// Relative imports
import { addQueryParams, axiosInstance } from "./common.jsx";

// Services
export const createServiceWithWizard = async (data) => {
  const endpoint = "services/wizard/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const listCompanyServices = async (company_id) => {
  const endpoint = `services/company/${company_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createService = async (company_id, data) => {
  const endpoint = `services/company/${company_id}/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getService = async (service_id) => {
  const endpoint = `services/service/${service_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateService = async (service_id, data) => {
  const endpoint = `services/service/${service_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteService = async (service_id) => {
  const endpoint = `services/service/${service_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getServiceTypes = async (queryParams = {}, newEndpoint = null) => {
  let endpoint = newEndpoint || "services/service-types/";
  if (!newEndpoint) {
    endpoint = addQueryParams(endpoint, queryParams);
  }
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createServiceType = async (data) => {
  const endpoint = "services/service-types/";
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getServiceTypeById = async (service_type_id) => {
  const endpoint = `services/service-types/${service_type_id}/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateServiceType = async (service_type_id, data) => {
  const endpoint = `services/service-types/${service_type_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteServiceType = async (service_type_id) => {
  const endpoint = `services/service-types/${service_type_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getSubServiceTypes = async (service_type_id) => {
  const endpoint = `services/service-types/${service_type_id}/subservice-types/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const createSubServiceType = async (service_type_id, data) => {
  const endpoint = `services/service-types/${service_type_id}/subservice-types/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateSubServiceType = async (subservice_type_id, data) => {
  const endpoint = `services/subservice-types/${subservice_type_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteSubServiceType = async (subservice_type_id) => {
  const endpoint = `services/subservice-types/${subservice_type_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// SubServiceItems
export const createSubServiceItem = async (subservice_type_id, data) => {
  const endpoint = `services/subservice-types/${subservice_type_id}/subservice-items/`;
  return axiosInstance
    .post(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const updateSubServiceItem = async (subservice_item_id, data) => {
  const endpoint = `services/subservice-items/${subservice_item_id}/`;
  return axiosInstance
    .patch(endpoint, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const deleteSubServiceItem = async (subservice_item_id) => {
  const endpoint = `services/subservice-items/${subservice_item_id}/`;
  return axiosInstance
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
export const getSubServiceItems = async (service_type_id, subservice_type_id) => {
  const endpoint = `services/service-types/${service_type_id}/subservice-types/${subservice_type_id}/subservice-items/`;
  return axiosInstance
    .get(endpoint)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
